export const OPTION_ACTION_REQUIRED_USER = {
    value   : '{actionRequiredUserId}',
    label   : 'Action required user',
    icon    : 'i5-user-action-required'
}

export const OPTION_ASSIGNED_TO_USER = {
    value   : '{assignedToUserId}',
    label   : 'Assigned to user',
    icon    : 'i5-user-assigned'
}

export const OPTION_CURRENT_USER = {
    value   : '{currentUserId}',
    label   : 'Current user',
    icon    : 'i5-user-created'
}

export enum UsersSelectorGroupBy {
    NONE            = 'none',
    DEPARTMENT      = 'department',
    TEAMS           = 'team'
}